module.exports = __webpack_public_path__ + "img/arrow-left-grey.d5257401.png";